import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';
import { CURSOR} from '../../../styles/fonts/MCFontConstants';
export const PopupTitle = styled.div`
    color: ${({ color }) => (color ? color : '#130e4a')};
    opacity: 1;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 18px;
    ${media.mobileDevice` 
      justify-content: ${({ mbJustifyContent }) => (mbJustifyContent ? mbJustifyContent : '')};   
    `};
`;

export const Title = styled.div`
    text-align: ${({ textAlign }) => (textAlign ? textAlign : '')};
    font-size: ${({ DeskFontSize }) => (DeskFontSize ? DeskFontSize : '')};
    color: ${({ color }) => color && color};
    ${media.mobileDevice`    
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '')};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '')};
    width: ${({ width }) => (width ? width : '#130e4a')};
    `};
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
`;
export const Icon = styled.div`
    border: 1px solid #ffffff;
    opacity: 1;
    background: transparent url(${({ mobilePath }) => mobilePath}) 0% 0%
        no-repeat padding-box;
    width: ${({ iconWidth }) => (iconWidth ? iconWidth : '22px')};
    height: 23px;
    margin-top: 1px;
    display: ${({ hideIcon }) => (hideIcon ? 'none' : '')};
    cursor: ${CURSOR};
    ${media.mobileDevice`
    width: ${({ mbIconWidth }) => (mbIconWidth ? mbIconWidth : '29px')};
    margin-left : ${({ mbIconMarginLeft }) => ( mbIconMarginLeft ? mbIconMarginLeft : '')};
    `}
`;

export const PopupContent = styled.div`
    position: ${({ position }) => (position ? position : 'relative')};
    margin: ${({ margin }) => (margin ? '15px' : '0 auto')};
    width: ${({ contentWidth, emptyCartWidth }) =>
        emptyCartWidth ? emptyCartWidth : contentWidth && '770px'};
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: ${({ borderRadius }) =>
        borderRadius ? borderRadius : '12px'};
    padding: ${({ popupContentPadding }) =>
        popupContentPadding ? popupContentPadding : '15px 20px'};
    border: 1px solid #999;
    display: flex;
    display: -webkit-flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : 'column'};
    overflow-y: ${({ addProductSpecific }) =>
        addProductSpecific ? 'scroll' : ''};
    max-height: ${({ addProductSpecific }) =>
        addProductSpecific ? '500px' : ''};

    ${media.smalDevice`
        margin-left : ${({ SignatureMargin }) => SignatureMargin && '40px'};
        margin-right : ${({ SignatureMargin }) => SignatureMargin && '40px'};
        max-height: ${({ contentTabHeight, isFromPop }) =>
            !isFromPop && contentTabHeight && 'max-content'};  
        height :   ${({ contentTabHeight, shipAdressPopup, smalHeight }) =>
            (contentTabHeight && shipAdressPopup) || smalHeight
                ? '90%'
                : contentTabHeight && !shipAdressPopup && '102%'} ;
        margin-top :  ${({ contentTabHeight }) => contentTabHeight && '120px'} ;
        padding-bottom:${({ paddingBottom, shipAdressPopup }) =>
            shipAdressPopup &&
            (ENVIRONMENTVARIABLE
                ? `max(${
                      paddingBottom ? paddingBottom : '3vh'
                  },calc(4*env(safe-area-inset-bottom)))`
                : paddingBottom
                ? paddingBottom
                : '10vh')};
        background: ${({ backgroundColor }) =>
            backgroundColor && '#f5f5f5 0% 0% no-repeat padding-box'};
        width: ${({ mobileWidthB33Popup }) => mobileWidthB33Popup};
        flex-direction: ${({ flexDirection }) =>
            flexDirection ? flexDirection : ''};
    `}

    ${media.mobileDevice`
        width: ${({ mobileWidth, mobileWidthPercent }) =>
            mobileWidth
                ? '100%'
                : mobileWidthPercent
                ? mobileWidthPercent
                : ''};
        padding: ${({ popupContentPaddingMobile }) =>
            popupContentPaddingMobile};
        max-height: ${({ popHeight, isFromPop }) =>
            !isFromPop && popHeight && 'max-content'};  
        height :   ${({ popHeight, mobHeight }) =>
            popHeight || (mobHeight && '102% !important')} ;
        margin-left :  ${({ popHeight }) => popHeight && 'auto !important'} ;
        margin-right :${({ popHeight }) => popHeight && 'auto !important'} ;
        border-top-left-radius: ${({ borderTopLeftRadius }) =>
            borderTopLeftRadius};
        border-top-right-radius: ${({ borderTopRightRadius }) =>
            borderTopRightRadius};
        min-height: ${({ minHeight }) => minHeight};
        margin: ${({ mobileMargin }) => mobileMargin};
        top: ${({ top }) => top};
        background: ${({ mobileBg }) => mobileBg};
        overflow-y: ${({ mbOverflowY }) => mbOverflowY};
       // border-radius: 1px;
    `}

    ${media.exSmallDevice`
    margin-top :  ${({ popHeight }) => popHeight && '109px !important'} ;
`}
@media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation : landscape) {
        width: ${({ ipadwidth }) => ipadwidth};
        height: ${({ landscapeHeight }) => landscapeHeight};
        margin-top :  ${({ landscapeMarginTop }) => landscapeMarginTop} ;

    }
    @media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (orientation: portrait) {
        width: ${({ portraitWidth }) => portraitWidth};
    }
`;

export const PopupContainer = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ background }) =>
        background ? background : ' #000000cc 0% 0% no-repeat padding-box'};

    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    opacity: ${({ opacity }) => (opacity ? opacity : '1')};
    z-index: ${({ zIndex }) => (zIndex ? zIndex : 100000)};
    overflow: ${({ overflow }) => overflow};

    ${media.smalDevice`
    background :  ${({ contentTabHeight }) =>
        contentTabHeight
            ? '0% 0% no-repeat padding-box !important'
            : '#000000cc 0% 0% no-repeat padding-box'} ;
    `}
    ${media.mobileDevice`
    background :  ${({ popHeight, mbBackGround, isFromPop }) =>
        popHeight && !isFromPop
            ? '0% 0% no-repeat padding-box !important'
            : mbBackGround
            ? 'rgb(0 0 0 / 0%) 0% 0% no-repeat padding-box'
            : '#000000cc 0% 0% no-repeat padding-box'} ;            
    z-index: ${({ mobileZIndex }) => mobileZIndex};
    `}
    
    @media only screen and (max-width: 1024px) and (orientation: landscape) {
        background: #000000cc 0% 0% no-repeat padding-box !important;
        z-index: ${({ mobileZIndex }) => mobileZIndex || 100000} !important;
        // top:30px !important;
        };
    }
`;

export const Merge = styled.div`
    display: flex;
    flex-direction: row;
    width: ${({ webWidth }) => (webWidth ? webWidth : '')};
    height: ${({ webHeight }) => (webHeight ? webHeight : '')};
    ${media.mobileDevice`
    width: ${({ width }) => (width ? width : '')};
    align-items:${({ alignItemsMob }) =>
        alignItemsMob ? alignItemsMob : 'center'} ;
    margin-right:${({ mbMarginRight }) =>
        mbMarginRight ? mbMarginRight : ''} ;
    `}
`;

export const PopUpImage = styled.img.attrs((props) => ({
    src: props.img,
}))`
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '27px')};
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '5px'};
    padding-top: ${({ paddingTop }) => (paddingTop ? paddingTop : '2px')};
    margin-left: ${({ marginLeftDesktop }) =>
        marginLeftDesktop ? marginLeftDesktop : ''};
    align-self: flex-start; /* Aligns the icon to the top of the div */
    ${media.mobileDevice`
        margin-left: ${({ marginLeftMobile }) =>
            marginLeftMobile ? marginLeftMobile : ''};
        margin-top : ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    `}
`;

export const BackTitle = styled.p`
    color: #1010eb;
    font-family: 'AvenirNextWorld Regular';
    padding: 0;
    margin: 0;
    display: flex;
    cursor: pointer;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '1px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
    ${media.mobileDevice`
        margin: 0px 0 10px -7px;
        font-size: 16px;
    `}
`;
